import { ACTIONS } from './const';
import { routes, routeTitles } from './routes';

export default [
  {
    name: routeTitles.DASHBOARD,
    link: routes.DASHBOARD,
    icon: 'MdDashboard',
    namespacerAction: ACTIONS.DASHBOARD_NAV_OPEN,
    nestedNavItems: [
      {
        name: routeTitles.DASHBOARD_RECEIVABLES,
        link: routes.DASHBOARD_RECEIVABLES,
        type: 'static',
      },
      {
        name: routeTitles.DASHBOARD_COLLECTIONS,
        link: routes.DASHBOARD_COLLECTIONS,
        type: 'static',
      },
      {
        name: routeTitles.DASHBOARD_PROJECTIONS,
        link: routes.DASHBOARD_PROJECTIONS,
        type: 'static',
      },
    ],
  },
  {
    name: routeTitles.STATEMENTS,
    icon: 'CSIcon',
    namespacerAction: ACTIONS.STATEMENT_NAV_OPEN,
    nestedNavItems: [
      {
        name: routeTitles.INDIVIDUAL,
        link: routes.INDIVIDUAL,
        type: 'static',
      },
      {
        name: routeTitles.BULK,
        link: routes.BULK,
        type: 'static',
      },
    ],
  },
  {
    name: routeTitles.JOURNALS,
    icon: 'JIcon',
    namespacerAction: ACTIONS.JOURNALS_NAV_OPEN,
    nestedNavItems: [
      {
        name: routeTitles.JOURNALS,
        link: routes.JOURNALS,
        type: 'static',
      },
      {
        name: routeTitles.GL_CONFIG_SCREEN,
        link: routes.GL_CONFIG_SCREEN,
        type: 'static',
      },
      {
        name: routeTitles.GL_EXCEPTION_SCREEN,
        link: routes.GL_EXCEPTION_SCREEN,
        type: 'static',
      },
      {
        name: routeTitles.TRUST_GL_EXCEPTION_SCREEN,
        link: routes.TRUST_GL_EXCEPTION_SCREEN,
        type: 'static',
      },
      {
        name: routeTitles.TRUST_GL_CONFIG_SCREEN,
        link: routes.TRUST_GL_CONFIG_SCREEN,
        type: 'static',
      },
    ],
  },
  {
    name: routeTitles.TRUST,
    link: routes.TRUST,
    type: 'static',
    icon: 'FaHandHoldingUsd',
  },
  {
    name: routeTitles.REPORTS,
    link: routes.REPORTS,
    type: 'static',
    icon: 'BsFillFileEarmarkBarGraphFill',
  },
  {
    name: routeTitles.GLCONFIG,
    icon: 'IoSettings',
    namespacerAction: ACTIONS.GL_CONFIGURATION_NAV_OPEN,
    nestedNavItems: [
      {
        name: routeTitles.ACCOUNT_TYPE_DEFINITION,
        link: routes.ACCOUNT_TYPE_DEFINITION,
        type: 'static',
      },
      {
        name: routeTitles.SEGMENT_DEFINITION,
        link: routes.SEGMENT_DEFINITION,
        type: 'static',
      },
      {
        name: routeTitles.ACCOUNT_NUMBER,
        link: routes.ACCOUNT_NUMBER,
        type: 'static',
      },
      {
        name: routeTitles.GL_TEMPLATE,
        link: routes.GL_TEMPLATE,
        type: 'static',
      },
    ],
  },
];
